<template>
  <div id="references">
    <group-card title="References" icon="assignment_ind">
      <!-- <transition-group v-bind="transitions.expand"> -->

        <!-- Income array inputs -->
        <div
          v-for="(reference,index) in applicant.references"
          :key="id(reference)"
          >
          <div class="md-layout input-layout">

            <!-- Relationship -->
            <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-15"
              label="Relationship" v-model="reference.relationship" :prefixLabel="prefixLabel + ' ' + (index+1)"
              :options="options.reference_relationship"
            />

            <!-- Name -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-15"
              label="Name" v-model="reference.name" :prefixLabel="prefixLabel + ' ' + (index+1)">
            </validated-text-input>

            <!-- Phone Number -->
            <validated-text-input
              class="md-layout-item md-small-size-100 md-size-10"
              label="Phone Number"
              v-model="reference.phone"
              :prefixLabel="prefixLabel + ' ' + (index+1)"
              prefix="+"
              :minLength=7
              :maxLength=15
              errormsg="Please enter a valid phone number, format can contain 7 to 15 digits"
            />

            <!-- Email -->
            <validated-text-input
              class="md-layout-item md-small-size-100 md-size-15"
              label="Email"
              v-model="reference.email"
              :prefixLabel="prefixLabel + ' ' + (index+1)"
            />

            <!-- Search Address -->
            <search-address
                :prefixLabel="prefixLabel + ' ' + (index+ 1)"
                :disabled="disabled"
                :address="reference.address"
                @update-address="updateAddress"
            ></search-address>

            <md-checkbox
              class="md-layout-item md-small-size-50 md-size-10"
              v-model="reference.is_emergency_contact"
            >
              Emergency Contact
            </md-checkbox>

            <!-- remove button -->
            <div class="md-layout-item text-right">
              <md-button class="md-primary md-simple md-danger md-just-icon" @click="arrayRemove(applicant.references, reference)"><md-icon>close</md-icon></md-button>
            </div>

          </div>
        </div>
      <!-- </transition-group> -->

      <div class="md-layout">

        <!-- Add -->
        <div class="md-layout-item">
          <md-button class="md-primary md-sm" @click="addListItem">Add</md-button>
        </div>
      </div>
    </group-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import transitions from "@/components/utils/transitions";
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import { newReference } from "@/schema.js";
import SearchAddress from '@/components/SearchAddress.vue';

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    SearchAddress
  },
  data(){
    return {
      transitions
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
    disabled: false
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value },
      set(applicant){ this.$emit('input', applicant) },
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    addListItem(){
      this.applicant.references.push(newReference());
    },
    async updateAddress(data) {
        console.log(data);
        response.data.country = 'Australia';
        Object.assign(this.applicant.references[(this.applicant.references.length-1)], response.data);
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'reference_relationship',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
